import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';

import { ApiService } from '@services/api.service';
import { DownloadService } from '@services/download.service';
import { OrigemLancamento } from '../../../../shared/models/enums/origem-lancamento';
import { LancamentoPrincipal } from '../models/lancamento-principal';
import { BancoOrigemEnum } from '../../../../shared/models/enums/banco-origem-enum';
import { DadosConciliacao } from '../models/dados-conciliacao';
import { InformacoesSalvarConciliacao } from '../models/informacoes-salvar-conciliacao';
import { TipoLancamento } from '@models/tipo-lancamento';
import { ReconciliarLancamentosRequest } from '../models/reconciliar-lancamentos-request';

@Injectable({
  providedIn: 'root'
})
export class ConciliacaoApiService extends ApiService {

  baseUrlRoute: string = "conciliacao";

  constructor(
    public override http: HttpClient,
    private downloadService: DownloadService,
    private datePipe: DatePipe
  ) {
    super(http);
  }

  public importLancamento(file: File, origem: OrigemLancamento, tipoBanco: BancoOrigemEnum): Observable<LancamentoPrincipal[]> {
    const formData = new FormData();
    formData.append('formFile', file, file.name);

    const importFrom = origem === OrigemLancamento.Banco ?
      tipoBanco === BancoOrigemEnum.Itau ? "importar-itau" : "importar-bradesco"
      : "importar-caixa";
    return this.post<LancamentoPrincipal[]>(`/${this.baseUrlRoute}/${importFrom}`, null, formData);
  }

  public exportarConciliacao(dadosConciliacao: DadosConciliacao): void {
    const data = this.datePipe.transform(dadosConciliacao.data, 'yyyy_MM_dd');
    const fileName = `conciliacao_${dadosConciliacao.nomeBanco}_${data}`;
    this.downloadService.downloadFileFromRouteWithParameters(`/conciliacao-excel/${dadosConciliacao.contaId}/exportar-conciliacao/${dadosConciliacao.conciliacaoId}`, fileName, null);
  }

  public getDadosConciliacaoNova(contaId: number): Observable<DadosConciliacao> {
    return this.get<DadosConciliacao>(`/${this.baseUrlRoute}/${contaId}`);
  }

  public getDadosConciliacaoExistente(conciliacaoId: number): Observable<DadosConciliacao> {
    return this.get<DadosConciliacao>(`/${this.baseUrlRoute}/editar/${conciliacaoId}`);
  }

  public salvarConciliacao(info: InformacoesSalvarConciliacao): Observable<DadosConciliacao> {
    return this.post<DadosConciliacao>(`/${this.baseUrlRoute}`, null, info);
  }

  public editarLancamento(conciliacaoId: number, lancamento: LancamentoPrincipal): Observable<void> {
    return this.patch<void>(`/${this.baseUrlRoute}/${conciliacaoId}/editar-lancamento`, null, lancamento);
  }

  public deleteLancamento(lancamentoId: number, conciliacaoId: number): Observable<void> {
    return this.delete<void>(`/${this.baseUrlRoute}/${conciliacaoId}/lancamento/${lancamentoId}`);
  }

  public getTiposLancamento(): Observable<TipoLancamento[]> {
    return this.get<TipoLancamento[]>(`/tipos-lancamento`);
  }

  public alterarTipoLancamento(conciliacaoId: number, lancamentoId: number, tipoLancamentoId: number): Observable<TipoLancamento[]> {
    return this.patch<TipoLancamento[]>(`/${this.baseUrlRoute}/${conciliacaoId}/lancamento/${lancamentoId}/alterar-tipo/${tipoLancamentoId}`);
  }

  public reconciliarLancamentosAntigos(request: ReconciliarLancamentosRequest) {
    return this.http.get<DadosConciliacao>(`${this.baseUrl}/${this.baseUrlRoute}/reconciliar-lancamentos-antigos`, { params: request.toHttpParams() });
  }
}
